import { Box } from "@mui/material";
import React from "react";

const AccessDenied = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src="/access-denied.png" height={500} width={500} />
    </Box>
  );
};

export default AccessDenied;
